import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../core/et3-text";
import { SURFACE_BORDER } from "../../../../../../core/et3-theme/surface-constants";
import {
  MODERATION_ROW_FONT_SIZE,
  MODERATION_ROW_HEIGHT,
  MODERATION_ROW_PADDING,
  MODERATION_ROW_RADIUS_CSS
} from "../details-box-constants";

const ModerationRow = withLiteObserverAndTheme<{
  label: string;
  value: string;
  toneColor: string;
  backgroundColor: string;
  isActive: boolean;
  onPress: () => void;
}>((props) => {
  const { label, value, toneColor, backgroundColor, isActive, onPress, theme } =
    props;
  const { colors, unitX } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={0}
      height={MODERATION_ROW_HEIGHT}
      fDirection="row"
      alignItems="center"
      justifyContent="space-between"
      color={backgroundColor}
      style={{
        boxSizing: "border-box",
        width: "100%",
        border: isActive ? `1px solid ${toneColor}` : SURFACE_BORDER,
        borderRadius: MODERATION_ROW_RADIUS_CSS,
        paddingLeft: MODERATION_ROW_PADDING * unitX,
        paddingRight: MODERATION_ROW_PADDING * unitX,
        gap: MODERATION_ROW_PADDING * unitX,
        cursor: isActive ? "pointer" : "default"
      }}
      onClick={() => {
        if (isActive) {
          onPress();
        }
      }}
    >
      <Et3Text
        text={label}
        fontFamily={isActive ? "BOLD" : "MEDIUM"}
        fontSize={MODERATION_ROW_FONT_SIZE}
        color={isActive ? toneColor : colors.all.maastrichtBlue}
        isSpan={true}
        style={{ margin: 0 }}
      />
      <Et3Text
        text={value}
        fontFamily="LIGHT"
        fontSize={MODERATION_ROW_FONT_SIZE}
        color={isActive ? toneColor : colors.all.gray}
        isSpan={true}
        style={{ margin: 0, whiteSpace: "nowrap" }}
      />
    </ET3Div>
  );
});
export default ModerationRow;
